import React, { useState } from 'react';
import './HistoryEntry.css';

function HistoryEntry({ entry, onDelete }) {
  const [copied, setCopied] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopied(type);
    setTimeout(() => setCopied(null), 2000);
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return '今すぐ';
    if (diffMins < 60) return `${diffMins}分前`;
    if (diffHours < 24) return `${diffHours}時間前`;
    if (diffDays < 7) return `${diffDays}日前`;

    return date.toLocaleDateString('ja-JP', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const languages = {
    en: '英語',
    ja: '日本語',
    zh: '中国語',
    ko: '韓国語',
    fr: 'フランス語',
    es: 'スペイン語',
    de: 'ドイツ語',
  };

  return (
    <>
      <div className="history-entry-row" onClick={() => setExpanded(!expanded)}>
        <div className="entry-lang">
          {languages[entry.sourceLang]} → {languages[entry.targetLang]}
        </div>
        <div className="entry-original">
          <span className="entry-text">{truncateText(entry.original)}</span>
        </div>
        <div className="entry-translated">
          <span className="entry-text">{truncateText(entry.translated)}</span>
        </div>
        <div className="entry-time">
          {formatDate(entry.timestamp)}
        </div>
        <div className="entry-actions">
          <button
            className="btn-delete-compact"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(entry.id);
            }}
            title="削除"
          >
            🗑️
          </button>
        </div>
      </div>

      {expanded && (
        <div className="history-entry-expanded">
          <div className="expanded-content">
            <div className="expanded-section">
              <h4>元のテキスト ({languages[entry.sourceLang]})</h4>
              <p>{entry.original}</p>
              <button
                className={`copy-btn ${copied === 'original' ? 'copied' : ''}`}
                onClick={() => handleCopy(entry.original, 'original')}
              >
                {copied === 'original' ? '✓ コピーしました' : '📋 コピー'}
              </button>
            </div>
            <div className="expanded-section">
              <h4>翻訳 ({languages[entry.targetLang]})</h4>
              <p>{entry.translated}</p>
              <button
                className={`copy-btn ${copied === 'translated' ? 'copied' : ''}`}
                onClick={() => handleCopy(entry.translated, 'translated')}
              >
                {copied === 'translated' ? '✓ コピーしました' : '📋 コピー'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default HistoryEntry;
